import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Martín G., 45',
    city: 'Tandil',
    text: 'Doy clases en una escuela rural y siempre me costaba adaptar el contenido ambiental urbano. Este kit me salvó horas de planificación. Los proyectos son reales y aplicables al campo.',
    role: 'Profesor de ciencias naturales'
  }, {
    name: 'Carolina V., 33',
    city: 'Rafaela',
    text: 'Luchaba con materiales que no conectaban con mis alumnos. Este sistema está pensado exactamente para nuestra realidad rural. La huerta escolar fue un éxito total.',
    role: 'Docente rural'
  }, {
    name: 'Jorge A., 52',
    city: 'Entre Ríos',
    text: 'Compramos el sistema Pro para todos los docentes de la agrotécnica. La calidad técnica, las rúbricas y las evaluaciones listas son excelentes. Muy recomendable.',
    role: 'Director de escuela agrotécnica'
  }, {
    name: 'Lucía P., 38',
    city: 'Río Cuarto',
    text: 'Tener la planificación anual armada vale oro. Antes improvisaba semana a semana, ahora tengo todo estructurado. A los chicos les encantan las actividades de campo.',
    role: 'Profesora de educación ambiental'
  }, {
    name: 'Fernando D., 48',
    city: 'Pergamino',
    text: 'Los proyectos son súper prácticos. El tomo de problemáticas ambientales rurales toca temas que los chicos viven día a día. Se enganchan mucho más en clase.',
    role: 'Docente de escuela rural'
  }];
  return <section className="bg-[#0B211A] py-4 md:py-5 px-3 border-b border-[#1F3D2B]" data-id="element-208">
      <div className="max-w-5xl mx-auto" data-id="element-209">
        <h2 className="text-xl md:text-2xl font-black text-[#FFFFFF] text-center mb-3 uppercase tracking-tighter leading-tight" data-id="element-210">
          💬 TESTIMONIOS
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-3" data-id="element-211">
          {testimonials.map((t, i) => <div key={i} className="bg-[#102A1F] border border-[#1F3D2B] p-3 rounded flex flex-col shadow-sm" data-id="element-212">
              <div className="text-[#D4A843] text-xs mb-1 tracking-widest leading-none" data-id="element-213">
                ★★★★★
              </div>
              <p className="text-[#BFC9C5] font-bold text-xs md:text-sm mb-2 flex-grow italic leading-snug" data-id="element-214">
                "{t.text}"
              </p>
              <div className="border-t border-[#1F3D2B] pt-1.5" data-id="element-215">
                <p className="font-black text-[#FFFFFF] text-xs uppercase leading-none" data-id="element-216">
                  {t.name}
                </p>
                <p className="text-[9px] md:text-[10px] font-bold text-[#74C69D] uppercase mt-0.5 leading-none" data-id="element-217">
                  {t.role} • {t.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}